<template>
  <div class="h-px bg-grey-light-200 my-4" :class="className" />
</template>

<script setup lang="ts">
defineProps({
  className: {
    type: Array as () => string[],
    default: () => [''],
  },
});
</script>
